import { render, staticRenderFns } from "./JurisdictionalManagement.vue?vue&type=template&id=005013e6&scoped=true&"
import script from "./JurisdictionalManagement.vue?vue&type=script&lang=js&"
export * from "./JurisdictionalManagement.vue?vue&type=script&lang=js&"
import style0 from "./JurisdictionalManagement.vue?vue&type=style&index=0&id=005013e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005013e6",
  null
  
)

export default component.exports